<template>
  <div style="margin-bottom: -5px">
    <!--Without Drop Down-->
    <a :class="activeClassNoDropDown" v-if="menu.children.length === 0 "
       :href="mainPath"
       @click.prevent="parentMenuPath">
      <i :class='menu.menuIcon' class="menu-icon"></i>
      <span class="ml-2 menu-text" :title="menu.menuName">{{ menu.menuName }}</span>
    </a>
    <!--With Drop Down-->
    <a :class="activeClass" v-if="menu.children.length > 0"
       :href='"#"' @click="openOrCloseMenu()">
      <i :class='menu.menuIcon' class=" menu-icon"></i>
      <span class="ml-2 menu-text" :title="menu.menuName">{{ menu.menuName }}</span>
      <span class="float-md-right">
                <i :class="btn" class="icon-background1"></i>
            </span>
    </a>
    <!--Used for Tree Structure for li tag-->
    <ul class="nav" v-if="menu.children.length > 0 && (clicked || searchTerm) ">
      <li v-for="(child, idx) of menu.children" v-bind:key="idx">
        <a :class="activeClassChild(child)" v-if="child.children.length ==0"
           :href="href1(child)"
           @click.prevent="childMenuPath(child, menu)"
           :ref="'menuChild_' + child.menuId"
           tabindex="0">
          <span class="menu-text" :title="child.menuName">{{ child.menuName }}</span>
        </a>
        <!--With Drop Down-->
        <a :class="activeClassChild(child)" v-if="child.children.length > 0"
           :href='"#"' @click.prevent="openOrCloseChildMenu(child.menuId)">
          <i :class='child.menuIcon' class="menu-icon"></i>
          <span class="ml-2 menu-text" :title="child.menuName">{{ child.menuName }}</span>
          <span class="float-md-right">
                <i :class="childBtn" class="icon-background1"></i>
            </span>
        </a>
        <!--Used for Tree Structure for li tag-->
        <ul class="nav" v-if="child.children.length > 0 && (child.menuId==menuReg || searchTerm)">
          <li v-for="(child2, idx) of child.children" v-bind:key="idx">

            <a :class="activeClassChild2nd(child2)"
               :href="href1(child2)"
               :ref="'menu2Child_' + child2.menuId"
               @click.prevent="child2ndMenuPath(child2, menu)">
          <span class="menu-text" :title="child2.menuName">{{ child2.menuName }}</span>
            </a>

          </li>
        </ul>

      </li>
    </ul>
  </div>
</template>
<script>
import {bus} from '@/bus'
import store from "@/store";

export default {
  name: 'Menu',
  data() {
    return {
      clicked: false,
      childrenClicked: false,
      menuIsRestricted: false,
      submenuIsRestricted: false,
      menuPath: {},
      childClicked: false,
      menuReg: null,
      isMenuExpanded: false
    }
  },
  created() {
    bus.$on('menu-open', (m) => {
      if (m.id !== this.menu.syspk) {
        this.clicked = false;
      }
    });

    bus.$on('child-menu-open', (m) => {
      if (m.id !== this.menu.children.syspk) {
        this.childrenClicked = false;
      }
    });

    bus.$on('call-home-menu', this.homeMenu);
    if (store.state.isLoggedIn){
      this.redirectMenu()
    }

  },
  computed: {
    btn: function () {
      if (!this.clicked) return 'fa fa-plus-square fa-xs stroke-transparent custom-fa aln'
      else return 'fa fa-minus-square fa-xs stroke-transparent custom-fa aln'
    },
    childBtn: function () {
      if (!this.childrenClicked) return 'fa fa-plus-square fa-xs stroke-transparent custom-fa aln'
      else return 'fa fa-minus-square fa-xs stroke-transparent custom-fa aln'
    },
    mainPath: function () {
      return '#' + this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
    },
    activeClassNoDropDown: function () {
      if (this.menu.menuId === this.$store.state.childParentId && this.menu.parentMenuId === this.$store.state.parentMenuId)
        return 'nav-link text-left active'
      else return 'nav-link text-left ex1'
    },
    activeClass: function () {
      const currentPath = this.$route.path;
      const lastValue = currentPath.split('/').pop();
      const isSelfActive = this.menu.menuId === lastValue;
      const hasActiveChild = (this.menu.children || []).some(child => {
        if (child.menuId === lastValue) return true;
        if (Array.isArray(child.children)) {
          return child.children.some(child2 => child2.menuId === lastValue);
        }
        return false;
      });

      if (isSelfActive || hasActiveChild) {
        return 'nav-link text-left parent-active';
      } else {
        return 'nav-link text-left ex1';
      }
    },
  },
  methods: {
    emitMaxWidthForParent() {
      let maxLen = 0
      if (this.menu && this.menu.menuName) {
        maxLen = this.menu.menuName.length
      }
      if (Array.isArray(this.menu.children)) {
        this.menu.children.forEach(child => {
          if (child && child.menuName) {
            maxLen = Math.max(maxLen, child.menuName.length)
          }
          if (Array.isArray(child.children)) {
            child.children.forEach(child2 => {
              if (child2 && child2.menuName) {
                maxLen = Math.max(maxLen, child2.menuName.length)
              }
            })
          }
        })
      }
      bus.$emit('menu-parent-max-width', maxLen)
    },
    homeMenu() {
      let menuObject;

      const {homeDashboardMenuId} = this.$store.state.user;
      const roleLevelMenuId = this.$store.state.userRoleRestriction.homeDashboardMenuId;

      if (!homeDashboardMenuId) {
        menuObject = roleLevelMenuId;
        // console.log("Role level dashboard");
      } else {
        menuObject = homeDashboardMenuId;
        // console.log("User level dashboard");
      }

      const segments = menuObject.split('/');
      const lastSegment = segments.pop(); // Second-level menu ID
      const secondLastSegment = segments.pop(); // First-level menu ID
      const matchingChild = this.menu.children.find((child) => child.menuId === lastSegment);

      const firstLevelMenu = this.menu.children.find((child) => child.menuId === secondLastSegment);
      if (firstLevelMenu && !this.isMenuExpanded) {
        this.isMenuExpanded = true;
        this.clicked = true;
        this.menuReg = firstLevelMenu.parentMenuId;

        let secondLevelMenu = firstLevelMenu.children?.find((child) => child.menuId === lastSegment);


        this.$nextTick(() => {
          setTimeout(() => {
            if (secondLevelMenu) {
              this.clicked = true;
              this.menuReg = secondLevelMenu.parentMenuId;


              this.$nextTick(() => {
                setTimeout(() => {
                  this.clicked = true;
                  this.menuReg = secondLevelMenu.parentMenuId;

                  this.$nextTick(() => {
                    setTimeout(() => {
                      // console.log("inside the second level")
                      const secondLevelMenuElement = this.$refs['menu2Child_' + secondLevelMenu.menuId]?.[0];
                      // console.log("inside the second level value:", secondLevelMenuElement)

                      if (secondLevelMenuElement) {
                        secondLevelMenuElement.focus();
                      } else {
                        console.error("Second-level menu item not found in $refs or is not focusable.");
                      }
                    }, 200);
                  });
                }, 200);
              });
            } else {
              console.error("Second-level menu item not found.");
            }
          }, 200); // Small delay to ensure first-level is rendered
        });
      }
     /* else {
        console.error("First-level menu item not found.");
      }*/


      if (matchingChild) {
        this.clicked = true; // Expand parent menu
        this.menuReg = matchingChild.menuId; // Expand and highlight matching child menu
        this.$nextTick(() => {
          const matchingChildElement = this.$refs['menuChild_' + matchingChild.menuId]?.[0];
          if (matchingChildElement) {
            matchingChildElement.focus();
          } else {
            console.error("Menu item not found in $refs or is not focusable.");
          }
        });
      }
    },
    redirectMenu() {
      let menuObject = this.$store.state.redirectUrl;
      // console.log("setRedirectUrl", menuObject);

      const segments = menuObject.split('/');
      const lastSegment = segments.pop();       // Second-level menu ID
      const secondLastSegment = segments.pop(); // First-level menu ID
      const matchingChild = this.menu.children.find(child => child.menuId === lastSegment);

      const firstLevelMenu = this.menu.children.find(child => child.menuId === secondLastSegment);

      if (firstLevelMenu && !this.isMenuExpanded) {
        this.isMenuExpanded = true;
        this.clicked = true;
        this.menuReg = firstLevelMenu.parentMenuId;

        let secondLevelMenu = firstLevelMenu.children?.find(child => child.menuId === lastSegment);

        this.$nextTick(() => {
          setTimeout(() => {
            if (secondLevelMenu) {
              this.clicked = true;
              this.menuReg = secondLevelMenu.parentMenuId;

              this.$nextTick(() => {
                setTimeout(() => {
                  this.clicked = true;
                  this.menuReg = secondLevelMenu.parentMenuId;

                  this.$nextTick(() => {
                    setTimeout(() => {
                      // console.log("Inside second level");

                      const secondLevelMenuElement = this.$refs['menu2Child_' + secondLevelMenu.menuId]?.[0];
                      // console.log("Second-level menu element ref:", secondLevelMenuElement);

                      if (secondLevelMenuElement) {
                        // Trigger click instead of focus
                        secondLevelMenuElement.click();
                        secondLevelMenuElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

                      } else {
                        console.error("Second-level menu item not found in $refs.");
                      }
                    }, 200);
                  });
                }, 200);
              });
            } else {
              console.error("Second-level menu not found.");
            }
          }, 200);
        });
      } /*else {
        console.error("First-level menu item not found.");
      }*/

      if (matchingChild) {
        this.clicked = true;
        this.menuReg = matchingChild.menuId;

        this.$nextTick(() => {
          const matchingChildElement = this.$refs['menuChild_' + matchingChild.menuId]?.[0];

          if (matchingChildElement) {
            // Trigger click instead of focus
            matchingChildElement.click();
            matchingChildElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

          } else {
            console.error("First-level menu item not found in $refs.");
          }
        });
      }
    }
    ,
    openOrCloseMenu() {
      this.clicked = !this.clicked
      bus.$emit('menu-open', {id: this.menu.syspk, clicked: this.clicked})
      if (this.clicked) {
        this.emitMaxWidthForParent()
      }
    },
    openOrCloseChildMenu(menuId) {
      if (this.menuReg !== menuId) {
        this.menuReg = menuId
        this.childrenClicked = true
      } else {
        this.menuReg = null
        this.childrenClicked = false
      }
      this.menuPath.p = this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
      this.menuPath.pId = this.menu.menuId
      this.menuPath.c = menuId.menuPath + '/' + menuId.parentMenuId + '/' + menuId.menuId
      this.menuPath.cId = menuId.menuId
      this.$store.dispatch('loadMenuPath', this.menuPath)
      this.childClicked = true
    },
    href1(child) {
      return '#' + child.menuPath + '/' + child.parentMenuId + '/' + child.menuId
    },
    activeClassChild: function (child) {
      const currentPath = this.$route.path;
      const lastValue = currentPath.split('/').pop();

      const isSelfActive = lastValue === child.menuId;
      const hasActiveGrandChild = Array.isArray(child.children) && child.children.some(child2 => child2.menuId === lastValue);

      if (isSelfActive || hasActiveGrandChild) {
        return 'nav-link text-left active';
      } else {
        return 'nav-link text-left ex1';
      }
    },
    activeClassChild2nd: function (child) {
      const currentPath = this.$route.path;
      const lastValue = currentPath.split('/').pop();
      if (lastValue === child.menuId) {
        return 'nav-link text-left active';
      } else {
        return 'nav-link text-left ex1';
      }
    },
    async parentMenuPath() {
      this.$logClick({
        element: 'menu-navigation-button',
        action: 'menu-click',
        menuId: this.menu.parentMenuId,
        subMenuId: this.menu.menuId,
        route:this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
      });
      this.menuPath.p = this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
      this.menuPath.pId = this.menu.parentMenuId
      this.menuPath.cId = this.menu.menuId
      await this.$router.push(this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId)
      await this.$store.dispatch('loadMenuPath', this.menuPath)
    },
    async childMenuPath(child) {
      this.$logClick({
        element: 'menu-navigation-button',
        action: 'menu-click',
        menuId: this.menu.parentMenuId,
        subMenuId: this.menu.menuId,
        route:this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
        // menuId/submenuId will come from this.$route.params
      });
      this.menuPath.p = this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
      this.menuPath.pId = this.menu.menuId
      this.menuPath.c = child.menuPath + '/' + child.parentMenuId + '/' + child.menuId
      this.menuPath.cId = child.menuId
      await this.$router.push(child.menuPath + '/' + child.parentMenuId + '/' + child.menuId)
      await this.$store.dispatch('loadMenuPath', this.menuPath)
      this.childClicked = true
    },
    async child2ndMenuPath(child) {
      this.$logClick({
        element: 'menu-navigation-button',
        action: 'menu-click',
        menuId: this.menu.parentMenuId,
        subMenuId: this.menu.menuId,
        route:this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
        // menuId/submenuId will come from this.$route.params
      });
      this.menuPath.p = this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
      this.menuPath.pId = child.parentMenuId
      this.menuPath.c = child.menuPath + '/' + child.parentMenuId + '/' + child.menuId
      this.menuPath.cId = child.menuId
      await this.$router.push(child.menuPath + '/' + child.parentMenuId + '/' + child.menuId)
      await this.$store.dispatch('loadMenuPath', this.menuPath)
      this.childClicked = true
    },
  },
  props: {
    menu: Object,
    searchTerm: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
.nav {
  display: block;
  padding: 0;
  margin: 0;
}

/* Base link style (all levels) */
.nav-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #0b2745;
  color: #e4e9f2;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 0;
  text-decoration: none;
  border-radius: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  transition: background 0.2s ease, color 0.2s ease;
}

/* Icon + label alignment */
.nav-link .menu-icon {
  width: 20px;
  min-width: 20px;
  text-align: center;
  /* margin-right: 6px; */
  font-size: 14px;
  margin-left: 10px;
}

.nav-link .menu-text {
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Normal (non-active) state */
a.ex1 {
  color: #c0cad9;
}

/* Hover / focus */
a.ex1:hover,
a.ex1:focus {
  background: #12345a;
  color: #ffffff;
}

/* Active state (selected menu - leaf/child items) */
a.active {
  background: linear-gradient(90deg, #1b75ff, #1b9dff);
  color: #ffffff;
  font-weight: 600;
  box-shadow: inset 3px 0 0 #ffffff;
}

/* Active state for parent-level menu (lighter) */
a.parent-active {
  background: #184170;
  color: #ffffff;
  font-weight: 600;
}

/* Child menu items (indentation) */
ul.nav > li > a.nav-link {
  padding-left: 30px;
}

ul.nav ul.nav > li > a.nav-link {
  padding-left: 65px;
  font-size: 13px;
}

/* Remove old tree lines */
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li {
  margin: 0;
  position: relative;
  font-size: 13px;
  text-align: left;
}

ul li::before,
ul li::after {
  content: none;
}

/* Expand / collapse icon on the right */
.icon-background1 {
  font-weight: normal;
  /* padding-left: 8px; */
  color: #eff0f2;
  margin-right: 10px;
}

</style>